import React from 'react';
export function Footer() {
  return <footer className="py-8 bg-[#020205] text-center text-gray-600 text-sm border-t border-white/5" data-id="element-158">
      <div className="container mx-auto px-4" data-id="element-159">
        <p data-id="element-160">
          © {new Date().getFullYear()} El Arte de Monetizar. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-161">
          Este sitio no es parte de Facebook o Facebook Inc.
        </p>
      </div>
    </footer>;
}